import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import taskModuleState from "./state";
import taskStoreData from "Stores/taskData";
import { taskTypeIcon } from "Static/constant";
import Utils from "Utils/utils";
import PaginationComponent from "Components/common/PaginationComponent";
import { ReactComponent as TaskIcon } from "Assets/svg/task.svg";
import TaskDetailLoader from "./TaskDetailLoader";

const TaskDetail = observer(props => {
  const history = useHistory();
  const [upcomingTasks, setUpcomingTasks] = useState([]);
  const [dueTasks, setDueTasks] = useState([]);
  const [expandedSections, setExpandedSections] = useState({
    due: true,
    upcoming: false
  });

  const getTaskTypeAndIcon = taskType => {
    return (
      <span className={`taskTypeWrapper ${taskType}`}>
        <span className="taskTypeIcon">{taskTypeIcon?.[taskType]?.icon}</span>
        <span className="taskTypeLabel">{taskTypeIcon?.[taskType]?.label}</span>
      </span>
    );
  };

  const getNotes = (note = "", touchPoint = {}) => {
    const { notes = "" } = touchPoint || {};
    let tempString = note || notes || "";
    return tempString?.replace(/\r?\n/g, " ") || "--";
  };

  const getTaskDue = dueDateObj => {
    return (
      <div
        className="taskDueDate"
        style={{
          color: dueDateObj.color
        }}
      >
        <>
          <i className="material-icons">schedule</i>
          <span>{dueDateObj.dueDate}</span>
        </>
      </div>
    );
  };

  const getContactOwner = (firstName, lastName, email) => {
    return (
      <div className="contactOwner">
        {Utils.getOwnerInitial({
          firstName,
          lastName,
          email
        })}
      </div>
    );
  };

  const getTaskActionButton = (taskType, taskId) => {
    const handleTaskClick = () => {
      if (taskId) {
        taskStoreData.setCurrentTaskId(taskId);
        history.push(`/tasks/start/${taskId}`);
      }
    };

    let buttonText = "View Task";
    if (taskType?.toLowerCase() === "phone") {
      buttonText = "Start Call";
    } else if (
      taskType?.toLowerCase() === "email" ||
      taskType?.toLowerCase() === "manualemail"
    ) {
      buttonText = "Send Email";
    } else if (taskType?.toLowerCase() === "linkedin") {
      buttonText = "View Task";
    } else if (taskType?.toLowerCase() === "customtask") {
      buttonText = "View Task";
    }

    return (
      <button
        className="taskActionButton"
        onClick={handleTaskClick}
        type="button"
      >
        {buttonText}
      </button>
    );
  };

  const toggleSection = section => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  useEffect(() => {
    // Fetch due tasks
    taskModuleState.getDueTasksData(taskModuleState?.activeTab || null, 1);
  }, [taskModuleState?.activeTab]);

  useEffect(() => {
    // Fetch upcoming tasks
    taskModuleState.getUpcomingTasksData(taskModuleState?.activeTab || null, 1);
  }, [taskModuleState?.activeTab]);

  useEffect(() => {
    if (taskModuleState?.dueTasksData?.tasks) {
      setDueTasks(taskModuleState.dueTasksData.tasks);
    } else {
      setDueTasks([]);
    }
  }, [taskModuleState?.dueTasksData]);

  useEffect(() => {
    // Update upcoming tasks from API response
    if (taskModuleState?.upcomingTasksData?.tasks) {
      setUpcomingTasks(taskModuleState.upcomingTasksData.tasks);
    } else {
      setUpcomingTasks([]);
    }
  }, [taskModuleState?.upcomingTasksData]);

  const paginate = pageNoObj => {
    if (!props?.loading) {
      const pageNo = pageNoObj.selected ? pageNoObj.selected + 1 : 1;
      const filter =
        taskModuleState?.activeTab === "total"
          ? null
          : taskModuleState?.activeTab;
      // Fetch both due and upcoming tasks with pagination
      taskModuleState.getDueTasksData(filter, pageNo);
      taskModuleState.getUpcomingTasksData(filter, pageNo);
    }
  };

  const renderTaskItem = (dataMap, index) => {
    if (!dataMap || !Object.keys(dataMap).length) return null;

    let { task = {}, contact = {} } = dataMap;
    let {
      firstName = "",
      lastName = "",
      email = "",
      name = ""
    } = contact || {};
    let {
      taskDue = "",
      note = "",
      taskType = "",
      touchPoint = "",
      id = ""
    } = task;

    const dueDateObj = Utils.getDueDateToRender(
      touchPoint?.scheduleDate || taskDue
    );
    const notesString = getNotes(note, touchPoint);
    const taskKey = id || `task-${index}`;

    return (
      <div className="taskSectionDetail" key={taskKey}>
        <div className="taskTypeIcon">{getTaskTypeAndIcon(taskType)}</div>
        <div className="taskEmail">
          <div className="taskContactName">{firstName || name || email}</div>
          <div className="taskContactEmail">{email || "--"}</div>
        </div>
        <div className="taskNotes">
          <span className="notes" title={notesString}>
            {notesString}
          </span>
        </div>
        {getTaskDue(dueDateObj)}
        <div className="taskActionButtonWrapper">
          {getTaskActionButton(taskType, id)}
        </div>
      </div>
    );
  };

  const renderTaskSection = (title, tasks, sectionKey, color) => {
    const isExpanded = expandedSections[sectionKey];
    const hasTasks = tasks && tasks.length > 0;

    return (
      <div className="taskGroupSection" key={sectionKey}>
        <div
          className={`taskGroupHeader taskGroupHeader-${sectionKey}`}
          style={{ color: color }}
          onClick={() => toggleSection(sectionKey)}
        >
          <span className="taskGroupTitle">
            {title} ({tasks?.length || 0})
          </span>
          <i className="material-icons">
            {isExpanded ? "expand_less" : "expand_more"}
          </i>
        </div>
        {isExpanded && hasTasks && (
          <div className="taskGroupContent">
            {tasks.map((dataMap, index) => renderTaskItem(dataMap, index))}
          </div>
        )}
        {isExpanded && !hasTasks && (
          <div className="taskGroupContent has-no-tasks">
            <div className="no-tasks-in-section">
              <span className="taskIcon">
                <TaskIcon />
              </span>
              <span className="noTaskText">No Tasks found</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  const totalTasks = dueTasks.length + upcomingTasks.length;

  return (
    <>
      <div
        className={`taskSectionDetailWrapper ${
          totalTasks > 0 ? "" : "noTaskWrapper"
        }`}
      >
        {taskModuleState?.dueTasksLoading ||
        taskModuleState?.upcomingTasksLoading ? (
          <div className="taskGroupsContainer">
            {taskModuleState?.dueTasksLoading && (
              <TaskDetailLoader
                isExpanded={expandedSections.due}
                sectionKey="due"
                color="#2F7EDA"
              />
            )}
            {taskModuleState?.upcomingTasksLoading && (
              <TaskDetailLoader
                isExpanded={expandedSections.upcoming}
                sectionKey="upcoming"
                color="#F49730"
              />
            )}
          </div>
        ) : (
          <div className="taskGroupsContainer">
            {renderTaskSection("Due", dueTasks, "due", "#2F7EDA")}
            {renderTaskSection(
              "Upcoming",
              upcomingTasks,
              "upcoming",
              "#F49730"
            )}
          </div>
        )}
      </div>
      <PaginationComponent
        callback={paginate}
        loading={
          taskModuleState?.dueTasksLoading ||
          taskModuleState?.upcomingTasksLoading
        }
        totalPages={Math.max(
          taskModuleState?.dueTasksData?.totalPages || 0,
          taskModuleState?.upcomingTasksData?.totalPages || 0
        )}
        currentPage={
          taskModuleState?.dueTasksData?.currentPage ||
          taskModuleState?.upcomingTasksData?.currentPage ||
          1
        }
      />
    </>
  );
});

export { TaskDetail };
export default TaskDetail;
